import { useState, useRef, useEffect } from "react";
import {
  PremiumPubBannerWrapper,
  PremiumPubBannerImage,
  PremiumPubBannerArrow,
} from "./style";
import { Swiper, SwiperSlide } from "swiper/react";
import { usePubContext } from "../../hooks/pub-context";
import { Autoplay } from "swiper/modules";
import { Swiper as SwiperType } from "swiper";
import PremiumPubBannerInfo from "./components/banner-info/banner-info";
import PremiumPubBannerSkeleton from "./skeleton";
import ImageViewer from "../../../../../components/ImageViewer";

const PremiumPubBanner = () => {
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const [seleteBannerIndex, setSeleteBannerIndex] = useState(-1);
  const { data, setShowHeader, loading } = usePubContext();
  const swiperRef = useRef<SwiperType | null>(null);
  const bannerRef = useRef<HTMLDivElement>(null);

  // header 투명 여부
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        if (target.isIntersecting) {
          setShowHeader(true);
        } else {
          setShowHeader(false);
        }
      },
      {
        threshold: 0.4, // 10% 보일 때 트리거
      }
    );

    if (bannerRef.current) {
      observer.observe(bannerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [bannerRef.current]);

  // 배너 이미지 이동 함수
  const handleCurrentIndex = (offset: number) => {
    if (!data || data?.images.length === 0) return;

    const total = data.images.length;
    let newIndex = currentBannerIndex + offset;

    if (newIndex < 0) newIndex = 0;
    if (newIndex > total - 1) newIndex = total - 1;

    setCurrentBannerIndex(newIndex);
    // 해당 index로 이동
    swiperRef.current?.slideTo(newIndex);
  };

  if (loading || !data?.images) return <PremiumPubBannerSkeleton />;

  return (
    <PremiumPubBannerWrapper ref={bannerRef}>
      <Swiper
        onSwiper={(swiper: SwiperType) => (swiperRef.current = swiper)}
        onRealIndexChange={(swiper: SwiperType) =>
          setCurrentBannerIndex(swiper.realIndex || 0)
        }
        slidesPerView={1}
        centeredSlides={true}
        modules={[Autoplay]}
        autoplay={{ delay: 3000 }}
      >
        {data?.images.length === 0 ? (
          <SwiperSlide>
            <PremiumPubBannerImage>
              <img
                src="https://dfesoodpx4jgd.cloudfront.net/cafe/default.png"
                alt="pub_image"
              />
            </PremiumPubBannerImage>
          </SwiperSlide>
        ) : (
          data?.images.map((item, index) => (
            <SwiperSlide key={index}>
              <PremiumPubBannerImage
                onClick={() => setSeleteBannerIndex(index)}
              >
                <img src={item.imageUrl} alt="pub_image" />
              </PremiumPubBannerImage>
            </SwiperSlide>
          ))
        )}
      </Swiper>
      <PremiumPubBannerArrow
        isLeft={true}
        onClick={() => handleCurrentIndex(-1)}
      >
        <img alt="left" src="/image-web/store/Btn/arrow-left.svg" />
      </PremiumPubBannerArrow>
      <PremiumPubBannerArrow
        isLeft={false}
        onClick={() => handleCurrentIndex(1)}
      >
        <img alt="right" src="/image-web/store/Btn/arrow-right.svg" />
      </PremiumPubBannerArrow>
      <PremiumPubBannerInfo
        currentBannerIndex={currentBannerIndex + 1}
        total={data?.images.length || 0}
      />
      {seleteBannerIndex !== -1 && (
        <ImageViewer
          images={data.images.map((x) => x.imageUrl)}
          defaultIndex={seleteBannerIndex}
          onClose={() => setSeleteBannerIndex(-1)}
          canEdit={data.myCafe}
        />
      )}
    </PremiumPubBannerWrapper>
  );
};

export default PremiumPubBanner;
